module.exports = "/wwwroot/img/start_page.png?ver=017a9fe8";